export const IGNORED_ERROR_MESSAGE_PATTERNS: RegExp[] = [
  /ResizeObserver loop limit exceeded/i,
  /ResizeObserver loop completed with undelivered notifications/i,
  /Non-Error promise rejection captured/i,
  /Network request failed/i,
  /NetworkError when attempting to fetch resource/i,
  /Failed to fetch/i,
  /Load failed/i,
  /The operation was aborted/i,
  /The user aborted a request/i,
  /AbortError/i,
  /cancelled/i,
  /Request aborted/i,
  /Loading chunk \d+ failed/i,
  /Loading CSS chunk \d+ failed/i,
  /Importing a module script failed/i,
  /Failed to load resource/i,
  /chrome-extension:\/\//i,
  /moz-extension:\/\//i,
  /safari-extension:\/\//i,
  /safari-web-extension:\/\//i,
  /Extension context invalidated/i,
  /ECONNRESET/i,
  /EPIPE/i,
  /ETIMEDOUT/i,
  /ECONNABORTED/i,
];

export const IGNORED_ERROR_TYPES: string[] = [
  "AbortError",
  "ResizeObserverError",
];

interface SentryEventLike {
  level?: string | null;
  message?: string | null;
  exception?: {
    values?: Array<{ type?: string | null; value?: string | null }>;
  } | null;
}

interface SentryHintLike {
  originalException?: unknown;
}

function getErrorMessages(
  event: SentryEventLike,
  hint: SentryHintLike | undefined,
): string[] {
  const messages: string[] = [];
  if (event.message) messages.push(event.message);
  const exc = event.exception?.values;
  if (exc) {
    for (const v of exc) {
      if (v?.value) messages.push(v.value);
      if (v?.type) messages.push(v.type);
    }
  }
  const orig = hint?.originalException;
  if (orig instanceof Error) {
    messages.push(orig.message);
    messages.push(orig.name);
  } else if (typeof orig === "string") {
    messages.push(orig);
  }
  return messages;
}

function getErrorTypes(
  event: SentryEventLike,
  hint: SentryHintLike | undefined,
): string[] {
  const types: string[] = [];
  const exc = event.exception?.values;
  if (exc) {
    for (const v of exc) {
      if (v?.type) types.push(v.type);
    }
  }
  const orig = hint?.originalException;
  if (orig instanceof Error) types.push(orig.name);
  return types;
}

export function shouldIgnoreSentryEvent(
  event: SentryEventLike,
  hint?: SentryHintLike,
): boolean {
  const types = getErrorTypes(event, hint);
  for (const t of types) {
    if (IGNORED_ERROR_TYPES.includes(t)) return true;
  }
  const messages = getErrorMessages(event, hint);
  for (const msg of messages) {
    for (const pattern of IGNORED_ERROR_MESSAGE_PATTERNS) {
      if (pattern.test(msg)) return true;
    }
  }
  return false;
}
